import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LanguageProvider } from "./config/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider> 
      {/* We wrap the entire app with the language provider 
      to give the whole application access to its context */}
        <App />
    </LanguageProvider>
  </React.StrictMode>
);

reportWebVitals();
